import React, { FC, useMemo } from 'react';
import qs from 'qs';
import { DfMapProps } from './type';

const classPrefix = `dffl-m-df-map`;

// 特殊规则——用:分割，;拼接
const RULE_GROUP = ['coord', 'title', 'addr'];

const DfMap: FC<DfMapProps> = (props) => {
  const { mapProps, locationInfo, iframeProps = {} } = props;

  /**
   * @description: 拼接参数
   * @param {any} data
   * @return {*}
   */
  const queryMapProps = (data: any) => {
    // 链接符
    let assginSyb = '=';
    // 拼接符
    let joinSyb = '&';
    const mapKeys = Object.keys(data);
    // 拼出片段 a=b&c=d or a:b;c:d;
    const mapKeysList = mapKeys.map((keyItem) => {
      let mapValue = data[keyItem];
      if (Array.isArray(data[keyItem])) {
        mapValue = mapValue.join(',');
      } else if (typeof data[keyItem] === 'object') {
        mapValue = queryMapProps(data[keyItem]);
      }
      if (RULE_GROUP.includes(keyItem)) {
        assginSyb = ':';
        joinSyb = ';';
      }
      return `${keyItem}${assginSyb}${mapValue}`;
    });
    return mapKeysList?.join(joinSyb) || '';
  };

  /**
   * @description: 处理mapprops拼到src中
   * @param {*} useMemo
   * @return {*} mapQuery
   */
  const mapQuery = useMemo(() => {
    // 当前这个存在，说明直接使用，仅经纬度等参数（同mark参数)，无其他
    if (locationInfo) {
      return `marker=${queryMapProps(locationInfo)}`;
    }
    // 兼容官网的使用，入参进来进行二次处理，拼成链接
    else {
      // const { coord = [31.40527, 121.48941], title = "未知地址", addr = "未知地址" } = mapProps?.mark || {}
      return queryMapProps(mapProps);
    }
  }, [props]);

  /**
   * @description: 处理高德/腾讯地图的url
   */
  const mapUrl = useMemo(() => {
    const { title, addr, latitude, longitude } =
      locationInfo ??
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
      }) ??
      {};
    const ua = navigator.userAgent.toLowerCase();
    const version = {
      isIOS: /iphone|ipad|ipod/.test(ua), //iphone
      isAndroid: /android/.test(ua), //android
      isDingTalk: ua.includes('dingtalk'), //钉钉
      isWeChat: ua.includes('micromessenger'), //微信
      isWeCom: ua.includes('wxwork'), //企业微信
      isLark: /lark|feishu/.test(ua), //飞书
      isBFDAPP: ua.includes('BFD-APP'), //百福得app
      isMAXAPP: ua.includes('MAX-APP'), //max app
    };
    // 微信
    if (version.isWeChat || version.isWeCom || true) {
      const positionStr = `marker=coord:${latitude},${longitude};title:${title ?? '--'};addr:${
        addr ?? '--'
      }`;
      return `https://apis.map.qq.com/tools/poimarker?${positionStr}&key=OE2BZ-6FWRQ-LFQ56-GOGXT-CKES2-OEBS2&referer=custom-medical`;
    } else {
      // 钉钉打开 不/支持微信
      const positionStr = `${longitude},${latitude}`;
      return `https://uri.amap.com/marker?position=${positionStr}&name=${
        title || '--'
      }&type=0&callnative=0&key=fe2793fc7b23ec89eb029824c4404119&referer=custom-medical`;
    }
  }, [mapQuery, mapProps, locationInfo]);

  return (
    <div className={classPrefix}>
      <iframe
        width="100%"
        height={window.innerHeight}
        style={{ border: 0 }}
        src={mapUrl}
        {...iframeProps}
      ></iframe>
    </div>
  );
};

export default DfMap;
